mutation setAsDefaultSender($senderId: ID!) {
  sender: setAsDefaultSender(senderId: $senderId) {
    id
    isDefault
    isVerified
    fromEmail
    isAcknowledged
    name
  }
}
